import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useProceduresChartsDataContext } from './hooks/useProceduresChartsDataContext';

export const EvolutionByProcedures = () => {
    const { chartData } = useProceduresChartsDataContext();


    return (
        <SimpleBars
            title={'Total de procedimentos (10 maiores)'}
            horizontal={true}
            subtitles={chartData?.evolutionByProcedures?.map((item) => item.description)}
            values={chartData?.evolutionByProcedures?.map((item) => item.total  ||  0)}
        />
    );
};
